import { useUserOrKioskQuery } from "../../common/lib/fetch";
import { QueryOptions } from "../../common/lib/fetch/useQuery";

export interface PastPurchaseOrder {
  purchaseOrderId: string;
  stagedPurchaseOrderId: string;
  purchaseOrderNumber: string;
  completedAt: string;
}

export const useGetPastPurchaseOrderByStagedPurchaseOrderId = (stagedPurchaseOrderId: string, options: QueryOptions<PastPurchaseOrder>) =>
  useUserOrKioskQuery<PastPurchaseOrder>({
    path: `/api/pastPurchaseOrders/${stagedPurchaseOrderId}`
  }, options);